package com.sddamico.swigmore.ds.navigation

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.PressableStyle
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.Anchor
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

data class NavTab(val label: String, val href: String)

/**
 * Header tabs (Poll · My Ballot · Computer Polls · Record Book · Commish). The active tab is a cream
 * chip. The row never wraps: on a phone it scrolls sideways, with the active tab scrolled into view.
 */
@Composable
fun NavTabs(tabs: List<NavTab>, active: NavTab?, modifier: Modifier = Modifier) {
  Div(
    attrs = Modifier.css("display" to "flex", "gap" to "4px", "flex-wrap" to "nowrap", "overflow-x" to "auto",
      "scrollbar-width" to "none")
      .then(modifier).toAttrs { attr("role", "navigation") }
  ) {
    tabs.forEach { tab ->
      val isActive = tab == active
      Anchor(
        href = tab.href,
        attrs = PressableStyle.toModifier()
          .typeCaps("11px", ".14em")
          .css("padding" to "8px 9px", "border-radius" to SwEffects.radiusSm, "text-decoration" to "none",
            "flex" to "0 0 auto", "white-space" to "nowrap",
            "background" to if (isActive) SwColor.cream else "transparent",
            "color" to if (isActive) SwColor.field700 else SwColor.cream)
          .toAttrs {
            if (isActive) {
              attr("aria-current", "page")
              ref { it.scrollIntoView(js("({ block: 'nearest', inline: 'nearest' })")); onDispose {} }
            }
          }
      ) { Text(tab.label) }
    }
  }
}
